var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmallIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 7,
    viewBox: "0 0 12 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.00005 6.9748C5.86672 6.9748 5.73738 6.9498 5.61205 6.8998C5.48672 6.8498 5.38272 6.78314 5.30005 6.6998L0.700048 2.0998C0.516715 1.91647 0.425049 1.68314 0.425049 1.3998C0.425049 1.11647 0.516715 0.883138 0.700048 0.699804C0.883382 0.516471 1.11672 0.424805 1.40005 0.424805C1.68338 0.424805 1.91672 0.516471 2.10005 0.699804L6.00005 4.5998L9.90005 0.699804C10.0834 0.516471 10.3167 0.424805 10.6 0.424805C10.8834 0.424805 11.1167 0.516471 11.3 0.699804C11.4834 0.883138 11.575 1.11647 11.575 1.3998C11.575 1.68314 11.4834 1.91647 11.3 2.0998L6.70005 6.6998C6.60005 6.7998 6.49172 6.8708 6.37505 6.9128C6.25838 6.9548 6.13338 6.97547 6.00005 6.9748Z",
    fill: "#606060"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallIcon);
export default __webpack_public_path__ + "static/media/SmallIcon.7d3ba6f9fa1b9ed0edfd41c4b448ea54.svg";
export { ForwardRef as ReactComponent };